import colors from '@tdcerhverv/parrotfish/dist/colors-design-token';
import { lighten } from '@mui/material/styles';
import { mix } from '../../utils/color-tools';

const { black, white } = colors;
export const palette = {
  common: {
    black,
    white,
  },
  primary: {
    contrastText: white,
    main: colors.primary,
    light: colors.primaryLight,
    dark: colors.primaryDark,
  },
  secondary: {
    contrastText: white,
    main: colors.secondary,
    light: lighten(colors.secondary, 0.2),
    dark: colors.secondaryDark,
  },
  error: {
    contrastText: colors.errorLight,
    main: colors.error,
    light: colors.errorMediumLight,
    dark: colors.errorDark,
  },
  warning: {
    contrastText: colors.warningLight,
    main: colors.warning,
    light: colors.warningMediumLight,
    dark: colors.warningDark,
  },
  info: {
    contrastText: colors.infoLight,
    main: colors.info,
    light: colors.infoMediumLight,
    dark: colors.infoDark,
  },
  success: {
    contrastText: colors.successLight,
    main: colors.success,
    light: colors.successMediumLight,
    dark: colors.successDark,
  },
  grey: {
    50: mix(white, colors.greyLightest),
    100: colors.greyLightest,
    200: colors.greyLight,
    300: colors.greyMediumLight,
    400: colors.greyMedium,
    500: colors.greyMediumDark,
    600: colors.greyDark,
    700: mix(colors.greyDark, colors.greyDarkest),
    800: colors.greyDarkest,
    900: mix(black, colors.greyDarkest),
  },
  text: {
    primary: black,
    secondary: colors.greyDark,
    disabled: colors.greyMediumLight,
    // hint: colors.greyMediumLight,
  },
  divider: colors.greyMediumLight,
  background: {
    default: white,
    paper: white,
  },
  orange: {
    main: colors.brandOrange,
    light: colors.brandOrangeLight,
    dark: colors.brandOrangeDark,
  },
  accent: colors.accent,
  accentDark: colors.accentDark,
};
